// Titulo de la pestana dentro de la app (/app, /admin). El HTML prerenderizado trae el de
// la pagina publica por la que se entro (p. ej. /asesores) y, sin esto, se quedaba puesto
// al navegar sin recargar. Las paginas que ya fijan el suyo devuelven null: AppLayout no
// lo pisa (sus efectos corren despues de los de la pagina).
// Las del Engine salen del catalogo `engine` (shell.titles.*) en el idioma que se pase; el resto, en es.
import i18n from "@/i18n";

const ENGINE = (s) => `QCapital Engine · ${s}`;
const ES = i18n.getFixedT("es", "engine");

const ENGINE_RULES = [
    [/^\/app\/engine\/?$/, "home"],
    [/^\/app\/engine\/carteras\//, "portfolio"],
    [/^\/app\/engine\/calculos\/?$/, "runs"],
    [/^\/app\/engine\/calculos\//, "run"],
    [/^\/app\/engine\/equipo\/?$/, "team"],
    [/^\/app\/engine\/actividad\/?$/, "activity"],
    [/^\/app\/engine\/ayuda\/?$/, "help"],
    [/^\/app\/engine\/comparar\/?$/, "compare"],
    [/^\/app\/engine\/firma\/?$/, "sign"],
];

const RULES = [
    [/^\/app\/engine\//, "QCapital Engine"],
    [/^\/admin\/engine\/?$/, ENGINE("Administración")],
    [/^\/admin\/engine\/[^/]+\/calculos\//, ENGINE("Cálculo (administración)")],
    [/^\/admin\/engine\/[^/]+\/?$/, ENGINE("Administración del despacho")],
    // Con titulo propio en la pagina.
    [/^\/app\/(optimizar|riesgo)(\/|$)/, null],
    [/^\/admin\/(blog|campaigns|announcements|coupons|influencers)(\/|$)/, null],
    [/^\/admin\/?$/, "Administración | QCapital"],
    [/^\/app\/dashboard/, "Dashboard | QCapital"],
    [/^\/app\/portfolios/, "Carteras | QCapital"],
    [/^\/app\/holdings/, "Activos | QCapital"],
    [/^\/app\/transactions/, "Transacciones | QCapital"],
    [/^\/app\/benchmarks/, "Benchmarks | QCapital"],
    [/^\/app\/alerts/, "Alertas | QCapital"],
    [/^\/app\/reports/, "Informes | QCapital"],
    [/^\/app\/dividends/, "Dividendos | QCapital"],
    [/^\/app\/rewind/, "Tu año | QCapital"],
    [/^\/app\/fiscal/, "Fiscal | QCapital"],
    [/^\/app\/referrals/, "Referidos | QCapital"],
    [/^\/app\/settings/, "Ajustes | QCapital"],
    [/^\/app\/billing/, "Facturación | QCapital"],
    [/^\/app\/help/, "Ayuda | QCapital"],
    [/^\/app\/connections/, "Conectar broker | QCapital"],
    [/^\/app\/import/, "Importar CSV | QCapital"],
    [/^\/app\/support/, "Soporte | QCapital"],
];

// engineT null: el catalogo `engine` aun no ha llegado, y vale el titulo generico antes que la clave.
export function appTitle(pathname, engineT = ES) {
    const engine = engineT && ENGINE_RULES.find(([re]) => re.test(pathname || ""));
    if (engine) return ENGINE(engineT(`shell.titles.${engine[1]}`));
    const hit = RULES.find(([re]) => re.test(pathname || ""));
    return hit ? hit[1] : "QCapital";
}
